/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect } from 'react';
import { Glance } from 'components/templates/glance';
import { LANGUAGE_OPTIONS, MEDIA_OPTION_LIST } from 'libs/constants';
import { withRouter, NextRouter } from 'next/router';

interface GlancePageProps {
  router: NextRouter;
  lang: string;
}

const GlancePage: React.FC<GlancePageProps> = ({ router, lang }) => {
  // const router = useRouter();

  useEffect(() => {
    if (router) {
      router.push(`/${lang}/glance/vision`, undefined, {
        scroll: false,
      });
    }
  }, [router, lang]);

  const handleOptionSelected = useCallback(
    (tab: number) => {
      const optionList = MEDIA_OPTION_LIST as any;
      if (optionList[tab]) {
        const optionItem = optionList[tab] as any;
        router.push(`/${lang}${optionItem.link}`, undefined, {
          scroll: false,
        });
      }
    },
    [lang, router]
  );
  return <Glance onOptionSelected={handleOptionSelected} />;
};

export default withRouter(GlancePage);

export async function getStaticPaths() {
  // generate path for static generation
  const paths: any = [];
  LANGUAGE_OPTIONS.forEach((item: any) => {
    paths.push({
      params: {
        lang: item.value,
      },
    });
  });
  return { paths, fallback: false };
}

export async function getStaticProps(args: any) {
  const { lang } = args.params;

  return {
    props: {
      lang,
    },
  };
}
